/*
 *
 */
import * as React from 'react';
import Page from '../components/page';
import Button from '../components/button';
import { StaticImage } from 'gatsby-plugin-image';

/*
 *
 */
const PageContent = () => {
	return (
		<Page
			title="La consultation pour enfant de 0 à 12 ans"
			intro="Vous vous inquiétez pour votre enfant qui vous semble ne pas allez bien ?"
			content={(
				<React.Fragment>

					<div style={{ marginBottom: '4rem' }}>
						<StaticImage
							className="limitheight"
							backgroundColor="rgba(255,255,255,.25)"
							src="../images/Enfants_1-Isabelle-Kopp.jpeg"
							alt="Consultation pour enfant - Isabelle Kopp"
							width={1920}
							sizes="(max-width: 768px) 50vw, 960px"
						/>
					</div>

					<p>
						Vous vous interrogez à propos de son comportement et/ou de ses symptômes qui par leurs fréquences et/ou leurs intensités ont des répercussions sur sa vie quotidienne, familiale, scolaire ou sociale.
					</p>

					<ul>
						<li>Difficulté de séparation</li>
						<li>Des peurs intenses ou des rituels envahissants</li>
						<li>Tristesse</li>
						<li>Troubles du sommeil</li>
						<li>Isolement</li>
						<li>
							Changement soudain de comportement :
							<ul>
								<li>Agressivité soudaine</li>
								<li>Enfant qui devient trop calme</li>
							</ul>
						</li>
						<li>Manque de confiance en soi, etc.</li>
					</ul>

					<p>
						Vos inquiétudes méritent toujours d’être entendue.
					</p>

					<p>
						Avant d’initier un suivi thérapeutique avec un enfant, une série d’entretiens préalables avec les parents ensemble ou séparément sont nécessaires afin de s’assurer de la bonne indication thérapeutique et d’établir une bonne alliance thérapeutique au bénéfice de votre enfant.
					</p>

					<p>
						Les consultations avec les tout-petits se passent toujours en présence d’un ou des parents. Durant le suivi thérapeutique de l’enfant, des rencontres avec les parents sont régulièrement prévues.
					</p>

					<p>
						Ces entrevues permettent un véritable travail d’équipe au bénéfice de l’enfant.
					</p>

					<div style={{ margin: '4rem 0', gap: '4rem', display: 'flex', width: '100%' }}>
						<div style={{ with: '100%' }}>
							<StaticImage
								backgroundColor="rgba(255,255,255,.25)"
								src="../images/Enfants_2-Isabelle-Kopp.jpeg"
								alt="Consultation pour enfant - Isabelle Kopp"
								width={960}
								sizes="(max-width: 768px) 230px, 460px"
							/>
						</div>
						<div style={{ with: '100%' }}>
							<StaticImage
								backgroundColor="rgba(255,255,255,.25)"
								src="../images/Enfants_3-Isabelle-Kopp.jpeg"
								alt="Consultation pour enfant - Isabelle Kopp"
								width={960}
								sizes="(max-width: 768px) 230px, 460px"
							/>
						</div>
					</div>

					<p>
						Le travail thérapeutique avec les enfants passe par la parole mais pas uniquement.
					</p>

					<p>
						Les enfants, surtout les tout-petits communiquent avant tout avec leur corps, ils rejouent ce qu’ils vivent à travers leurs jeux afin de tenter de comprendre ce qu’il vivent.
					</p>

					<p>
						Les jeux et les dessins sont utilisés par l’enfant comme médiateur pour s’exprimer et ils nous aident à le comprendre et à l’aider dans ses difficultés.
					</p>

					<br />
					<Button to="/rendez-vous/" label="Prendre un rendez-vous" />


				</React.Fragment>
			)}
		>
			<title>La consultation pour enfant de 0 à 12 ans — Isabelle Kopp</title>
		</Page>
	);
};

export default PageContent;
